// extracted by mini-css-extract-plugin
module.exports = {"card":"CardThree_card__3XYcF","bigHeader":"CardThree_bigHeader__C5WUd","button":"CardThree_button__2wZfT"};